/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useLazyQuery } from '@apollo/client';

import { GeneralContext } from '../../../../../core/app-context/GeneralContext';
import { GET_ORDER_DETAILS } from './graphql';

export function useGetOrderDetails({ orderId } = {}) {
  const { setLoading, setErrorMessage } = useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [apiData, setApiData] = useState(undefined);
  const [GetOrderDetails, { loading: apiLoading, error: apiError }] =
    useLazyQuery(GET_ORDER_DETAILS, { fetchPolicy: 'network-only' });

  useEffect(() => {
    if (orderId) {
      GetOrderDetails({
        variables: { orderId },
        onCompleted: (res) => {
          if (res.getOrder.code === 200) {
            setApiData(res.getOrder.order);
          } else {
            setErrorMessage(res.getOrder.message);
          }
        },
      });
    }
  }, [orderId]);

  useEffect(() => {
    setErrorMessage(apiError);
  }, [apiError]);

  useEffect(() => {
    setIsLoading(apiLoading);
    setLoading(apiLoading);
  }, [apiLoading]);

  async function getOrderDetails(otherOrderId) {
    try {
      const res = await GetOrderDetails({
        variables: { orderId: otherOrderId || orderId },
      });
      if (res.data.getOrder.code === 200) {
        setApiData(res.data.getOrder.order);
      } else {
        setErrorMessage(res.data.getOrder.message);
      }
    } catch (e) {
      setErrorMessage(e.message);
    }
  }

  return {
    getOrderDetails,
    orderDetails: apiData,
    loading: isLoading,
  };
}
